// extracted by mini-css-extract-plugin
export default {"welcomeBox":"welcome-box_welcomeBox__VBQA+","illustrationWrapper":"welcome-box_illustrationWrapper__1jh1B"};